import { cssModule, normalizeSize } from "../../shared";
import { useFieldContext } from "../../field";
/* eslint-disable sort-keys, sort-keys-fix/sort-keys-fix */

const Gap = {
  horizontal: {
    "sm": 4,
    "md": 5
  },
  vertical: {
    "sm": 2,
    "md": 3
  }
};
/* eslint-enable sort-keys, sort-keys-fix/sort-keys-fix */

export function useGroupInput({
  cssModule: module,
  disabled,
  gap,
  groupRef,
  isInField,
  orientation,
  required,
  reverse,
  role = "group",
  size,
  validationState,
  wrap
}) {
  const [{
    hasLabel,
    hasMessage
  }] = useFieldContext();
  return {
    groupProps: {
      align: orientation === "vertical" ? reverse ? "end" : "start" : undefined,
      "aria-disabled": disabled ? true : undefined,
      "aria-invalid": validationState === "invalid" ? true : undefined,
      "aria-orientation": role !== "group" ? orientation : undefined,
      "aria-required": required ? true : undefined,
      className: cssModule(module, hasLabel && "has-label", hasMessage && "has-message"),
      gap: gap !== null && gap !== void 0 ? gap : Gap[orientation][normalizeSize(size)],
      inline: reverse,
      orientation,
      ref: groupRef,
      role: !isInField ? role : undefined,
      wrap
    },
    itemProps: {
      disabled,
      reverse,
      size,
      validationState
    }
  };
}